import React, { type FC } from 'react'
import { Heading } from '@moonpig/launchpad-components'
import { useLocaleText } from './locale'

type Props = {
  activeStep: number
  totalSteps: number
}

export const StepHeading: FC<Props> = ({ totalSteps, activeStep }) => {
  const t = useLocaleText()

  const stepLabel = t('card_first_progress_indicator.step_prefix.label', {
    activeStep,
    totalSteps,
  })

  return (
    <Heading m={0} level="h6" typography="typeDisplay05">
      {stepLabel}
    </Heading>
  )
}
